import contactAddAccountModalTemplate from './contactAddAccountModal.html';

export default class ContactAddController {
    constructor($scope, $state, $stateParams, $ionicPopup, $ionicLoading, ApiContacts, ApiInvestors, ApiCampaigns, ApiTeam, ApiPicklist, DATE_FORMAT, MessageBox, $rootScope, $ionicModal) {
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.ApiContacts = ApiContacts;
        this.ApiInvestors = ApiInvestors;
        this.ApiPicklist = ApiPicklist;
        this.ApiTeam = ApiTeam;
        this.MessageBox = MessageBox;
        this.$rootScope = $rootScope;
    
        this.investors = [];
        this.contactInfo = {};
        this.contactInfo.contact = {};
        this.loading = [];
        this.filter = {};
        this.DATE_FORMAT = DATE_FORMAT;
        this.contactId = $stateParams.contactId;
        this.isCustomerContact = false;
        this.editMode = false; // flag true if new entry
        this.createInvestor = false;
        this.investorRedirect = false; // flag true if redirected from investor detail page
        this.translationVisible = false;
        this.contactInfo.contact.businessCardInformationReceivedDate = this.DATE_FORMAT ;
        this.contactInfo.contact.businessCardInformationLastUpdatedDate = this.DATE_FORMAT ;


        this.addAccountModal = $ionicModal.fromTemplate(contactAddAccountModalTemplate, { scope: $scope });
        this.accountTypes = [{ id: 'PACKAGE', value: 'advinda accounts', selected: true }, { id: 'TEAM', value: 'custom accounts', selected: false }];
        this.customCount = this.$stateParams.customCount;
        this.advindaCount = this.$stateParams.advindaCount;

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.cancelModal() != null) self.cancelModal();
        });

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        }



    }

    init() {

        if (this.editMode) {
            this.$rootScope.pageTitle = 'EDIT_CONTACT';
        } else {
            this.$rootScope.pageTitle = 'CREATE_CONTACT';
        }
        this.getInvestorTypes();
        this.getInvestorSubtypes();

        this.getCountries();
        this.getTeams();
        if (this.isEdit())
            this.getContact(this.contactId);
        if (this.isRedirectedFromInvestorsPage()) {
           
            this.contactInfo.investor = this.$stateParams.investor;
      
            this.copyInvestorToContact();
        }
    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length === 0)
            this.$ionicLoading.hide();
    }

    isEdit() {
        this.editMode = !!this.$stateParams.contactId;
        return this.editMode;
    }

    isRedirectedFromInvestorsPage() {
        this.investorRedirect = !!this.$stateParams.investor;
        return this.investorRedirect;
    }

    getContact(contactId) {
        this.showLoading();
        this.ApiContacts.getContact(contactId, { 'isCustomerContact': true }).then((contact) => {
            this.contactInfo = contact.contactInfo;
            this.setCardInfoDate();
            
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }

    getInvestorTypes() {
        this.showLoading();
        this.ApiPicklist.getInvestorTypes().then((investorTypes) => {
            this.investorTypes = investorTypes.data.map((investorType) => {
                return investorType.type;
            });
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }

    getCountries() {
        this.showLoading();
        this.ApiPicklist.getAdvindaCountries().then((advindaCountries) => {
            this.advindaCountries = advindaCountries.data;
            this.advindaCountries.unshift("");
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }


    saveContact() {
        this.checkCardInfoDate();
        if (this.isUpdatedDateNotAfterReceivedDate()) return;
        if (this.isEdit())
            this.editContact();
        else
            this.insertContact();
    }

    isUpdatedDateNotAfterReceivedDate() {
        if (this.contactInfo && this.contactInfo.contact && this.contactInfo.contact.businessCardInformationLastUpdatedDate && this.contactInfo.contact.businessCardInformationLastUpdatedDate !==this.DATE_FORMAT) {
            let receivedDate = this.contactInfo.contact.businessCardInformationReceivedDate
            let updatedDate = this.contactInfo.contact.businessCardInformationLastUpdatedDate;
            let flag = Date.parse(receivedDate) > Date.parse(updatedDate);
            return flag;
        }
        else{
          return false
        }
    }
    checkCardInfoDate(){
        if (this.contactInfo.contact.businessCardInformationReceivedDate  === this.DATE_FORMAT) {
            this.contactInfo.contact.businessCardInformationReceivedDate = null;
        }
        if (this.contactInfo.contact.businessCardInformationLastUpdatedDate  === this.DATE_FORMAT) {
            this.contactInfo.contact.businessCardInformationLastUpdatedDate = null;
        }
        
    }

    setCardInfoDate(){
        if (!this.contactInfo.contact.businessCardInformationReceivedDate ) {
            this.contactInfo.contact.businessCardInformationReceivedDate = this.DATE_FORMAT;
        }
        if (!this.contactInfo.contact.businessCardInformationLastUpdatedDate) {
            this.contactInfo.contact.businessCardInformationLastUpdatedDate = this.DATE_FORMAT;
        }
        
    }
    insertContact() {
        this.showLoading();
        this.ApiContacts.postContact(this.contactInfo).then((res) => {
            this.hideLoading();
            if (angular.isUndefined(res)) return;
            this.redirectAfterCreate(this.contactInfo);
        }, function () {
            this.hideLoading();
        });
    }

    editContact() {
        this.showLoading();
        this.ApiContacts.putContact(this.contactInfo).then((res) => {
            this.hideLoading();
            if (angular.isUndefined(res)) return;
            this.$state.go('contacts', {}, { reload: true });
        }, function () {
            this.hideLoading();
            this.MessageBox.showFailMessage('CONTACT', 'EDIT');
        });
    }

    redirectAfterCreate(contactInfo) {
        var customer = contactInfo.investor.customer;
        var investorId = contactInfo.investor.investorId;
        if (this.investorRedirect) {
            if (customer === null) {
                this.$state.go('investorsDetail', { investorId: investorId }, { isCustomerInvestor: false });
            } else {
                this.$state.go('customerInvestorsDetail', { investorId: investorId }, { isCustomerInvestor: true });
            }
        } else {
            this.$state.go('contacts', {}, { reload: true });
        }
    }

    clearInvestorInputs() {
        this.contactInfo.investor = {};
    }

    copyInvestorToContact() {
        if (this.contactInfo && this.contactInfo.investor) {
            if (this.checkIfKeyExistsInInvestorObject('fax')) {
                this.contactInfo.contact.fax = this.contactInfo.investor.fax;
            }
            if (this.checkIfKeyExistsInInvestorObject('billingCity')) {
                this.contactInfo.contact.mailingCity = this.contactInfo.investor.billingCity;
            }
            if (this.checkIfKeyExistsInInvestorObject('billingCountry')) {
                this.contactInfo.contact.mailingCountry = this.contactInfo.investor.billingCountry;
            }
            if (this.checkIfKeyExistsInInvestorObject('billingPostalCode')) {
                this.contactInfo.contact.mailingPostalCode = this.contactInfo.investor.billingPostalCode;
            }
            if (this.checkIfKeyExistsInInvestorObject('billingState')) {
                this.contactInfo.contact.mailingState = this.contactInfo.investor.billingState;
            }
            if (this.checkIfKeyExistsInInvestorObject('billingStreet')) {
                this.contactInfo.contact.mailingStreet = this.contactInfo.investor.billingStreet;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalPhone')) {
                this.contactInfo.contact.otherPhone = this.contactInfo.investor.additionalPhone;
            }
            if (this.checkIfKeyExistsInInvestorObject('investorPhone')) {
                this.contactInfo.contact.phone = this.contactInfo.investor.investorPhone;
            }
            if (this.checkIfKeyExistsInInvestorObject('postalCode')) {
                this.contactInfo.contact.mailingPostalCode = this.contactInfo.investor.postalCode;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalAddress')) {
                this.contactInfo.contact.additionalAddress = this.contactInfo.investor.additionalAddress;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalZip')) {
                this.contactInfo.contact.additionalZip = this.contactInfo.investor.additionalZip;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalCity')) {
                this.contactInfo.contact.additionalCity = this.contactInfo.investor.additionalCity;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalState')) {
                this.contactInfo.contact.additionalState = this.contactInfo.investor.additionalState;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalCountry')) {
                this.contactInfo.contact.additionalCountry = this.contactInfo.investor.additionalCountry;
            }
            if (this.checkIfKeyExistsInInvestorObject('additionalInformation')) {
                this.contactInfo.contact.additionalInformation = this.contactInfo.investor.additionalInformation;
            }


            if (this.checkIfKeyExistsInInvestorObject('countryTranslated')) {
                this.contactInfo.contact.countryTranslated = this.contactInfo.investor.countryTranslated;
            }
            if (this.checkIfKeyExistsInInvestorObject('stateTranslated')) {
                this.contactInfo.contact.stateTranslated = this.contactInfo.investor.stateTranslated;
            }
            if (this.checkIfKeyExistsInInvestorObject('zipTranslated')) {
                this.contactInfo.contact.zipTranslated = this.contactInfo.investor.zipTranslated;
            }
            if (this.checkIfKeyExistsInInvestorObject('cityTranslated')) {
                this.contactInfo.contact.cityTranslated = this.contactInfo.investor.cityTranslated;
            }
            if (this.checkIfKeyExistsInInvestorObject('addressTranslated')) {
                this.contactInfo.contact.addressTranslated = this.contactInfo.investor.addressTranslated;
            }
 
        }
    }

    checkIfKeyExistsInInvestorObject(key) {
        if (this.contactInfo && this.contactInfo.investor) {
            return (!!this.contactInfo.investor[key]);
        } else
            return false;
    }

    //
    // Account popup functions
    //

    showAccountModal() {
        this.addAccountModal.show();
        this.onInvestorContactsClick(0);
    }

    cancelModal() {
        this.searchPerformed = false;
        this.addAccountModal.hide();
    }

    closeModal() {
        this.searchPerformed = false;
        this.getInvestorsAndPopulateValues();
        this.addAccountModal.hide();
    }

    clearSearchAccounts() {
        this.searchAccountText = '';
        this.searchAccounts();
    }

    getInvestorSubtypes() {
        this.ApiInvestors.getInvestorsSubtypes().then((investorSubtypes) => {
            if (investorSubtypes) {
                this.investorSubtypes = investorSubtypes.map((subtype) => {
                    return { value: subtype };
                });
            }
        });
    }

    searchAccounts() {
        this.searchPerformed = true;
        this.filterParameterObj = {
            investorType: undefined,
            subtypes: [],
            selectionId: undefined,
            fromAum: undefined,
            toAum: undefined,
            searchText: this.searchAccountText,
            firstQueryResult: undefined,
            sortOrder: 'AUM',
            sortDirection: 'ASC'
        };

        if (this.filter.accountType.id === 'PACKAGE' && this.investorSubtypes != null) {
            this.investorSubtypes.forEach((subtype) => {
                this.filterParameterObj.subtypes.push(subtype.value);
            });
        }

        if (this.filter.accountType.id === 'PACKAGE') {
            this.loadPackageAccounts();
        } else {
            this.loadCustomAccounts();
        }
    }

    loadCustomAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then((investors) => {
            if (investors.length < 50) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = true;
            }

            this.investors = investors || [];
            this.loadingData = false;
        });
    }

    loadPackageAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then((investors) => {
            if (investors.length < 50) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = true;
            }

            this.investors = investors || [];
            this.loadingData = false;
        });
    }

    getMoreAccounts() {
        this.filterParameterObj.firstQueryResult = this.investors && this.investors.length;
        if (this.filter.accountType.id === 'PACKAGE') {
            this.getMorePackageAccounts();
        } else if (this.filter.accountType.id === 'TEAM') {
            this.getMoreCustomAccounts();
        }
    }

    getMorePackageAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then((investors) => {
            if (!investors) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = investors.length < 50 ? false : true;
                this.investors = this.investors.concat(investors);
                this.$scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingData = false;
        });
    }

    getMoreCustomAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then((investors) => {
            if (!investors) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = investors.length < 50 ? false : true;
                this.investors = this.investors.concat(investors);
                $scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingData = false;
        });
    }

    onInvestorContactsClick(buttonNumber) {
        this.accountTypes.map(c => c.selected = false);
        this.accountTypes[buttonNumber].selected = true;
        this.filter.accountType = this.accountTypes[buttonNumber];
        this.searchAccounts();
    }

    getInvestorsAndPopulateValues() {
        if (this.contactInfo.investor) {
            this.contactInfo.contact = this.removeAddressDetails();
            this.ApiInvestors.getInvestor(this.contactInfo.investor.investorId, {
                'isCustomerAccount': !!this.contactInfo.investor.customer
            }).then((investor) => {
                this.contactInfo.investor = investor.investor;
                this.copyInvestorToContact();
            })
        }
    }

    removeAddressDetails() {
        const contact = { ...this.contactInfo.contact };
        return {
            id: contact.id,
            salutation: contact.salutation,
            firstName: contact.firstName,
            lastName: contact.lastName,
            title: contact.title,
            email: contact.email,
            alternativeEmail: contact.alternativeEmail,
            customer: contact.customer,
            mobile: contact.mobile,
            businessCardInformationReceivedDate:  this.contactInfo.contact.businessCardInformationReceivedDate !== this.DATE_FORMAT ? 
              this.contactInfo.contact.businessCardInformationReceivedDate :this.DATE_FORMAT,
            businessCardInformationLastUpdatedDate: this.contactInfo.contact.businessCardInformationLastUpdatedDate !== this.DATE_FORMAT ? 
              this.contactInfo.contact.businessCardInformationLastUpdatedDate :this.DATE_FORMAT,

        }
    }
    getTeams(){

        this.ApiTeam.getTeams().then((res) => {
            if (typeof res != 'undefined') {
                if (res) {
                    this.translationVisible = res.translationRequired;
                }
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contactAdd.controller.js
 **/